import gql from 'graphql-tag';

export const DISMISS_NOTIFICATION = gql`
  mutation dismissDashboardNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      id
      active
    }
  }
`;

export const dismissNotificationMock = {
  updateNotification: {
    id: 1,
  },
};

export const mockNotification = {
  __typename: 'Notification',
  actionType: 'no_action',
  displayValues: {
    buttonText: 'Update payment method',
    message: 'Your payment method is expired.',
    title: 'Payment method expired',
  },
  id: 4,
  notificationKey: 'sign_contract',
  notifiableId: 1,
  priorityType: 'update',
  targetId: 15,
  utilityAccountDetails: {
    accountNumber: '123456789',
    displayServiceAddress: '123 Main St',
    utilityDisplayName: 'Utility Co',
  },
};
